import {Component} from '@angular/core';
import {ParamBaseComponent} from "../../../../bases/param-base-component";
import {ComponentType} from "@angular/cdk/overlay";
import {MetricsDimensionsPickerComponent} from "../../../metrics-dimensions-picker/metrics-dimensions-picker.component";
import {Observable} from "rxjs";
import {Serializer, Serializers} from "../../../../interfaces/serializer";
import {
  selectChannels,
  selectChannelsNotRequired
} from '../../../../store/channels/channels.selectors';
import {Channel} from "../../../../interfaces/channel";

@Component({
  selector: 'app-param-channel',
  templateUrl: './report-param-channel.component.html',
  styleUrls: ['./report-param-channel.component.scss']
})
export class ReportParamChannelComponent extends ParamBaseComponent {
  public readonly component: ComponentType<MetricsDimensionsPickerComponent> = MetricsDimensionsPickerComponent;
  public readonly options$: Observable<Serializers<Channel>> = this.paramDef.options?.notRequired && this._store.select(selectChannelsNotRequired) || this._store.select(selectChannels);
  public readonly textGetter: (channel: Serializer<Channel>) => string = (channel: Serializer<Channel>): string => channel.attributes.name;
}
